import React from "react"
import {FieldInlineEditableProps} from "../../../render/inline-editable";

// @ts-ignore
import FieldRenderEditableInlineTextarea from "./inline-editable/textarea-editable-inline";

export default function FieldText_InlineEditable(props: FieldInlineEditableProps) {

    const value = props.model[props.field.fieldId]

    const commonClasses = Classes("ui5-txt-default min-h-36 p-l-10 p-r-10 p-t-7 p-b-7 m-t-4 m-b-4", props.className, {
        'w-300': !props.className?.includes('w-')
    })

    return <FieldRenderEditableInlineTextarea editClasses   = {Classes("ui5-field-form-editable", commonClasses)}
                                              viewClasses   = {Classes("ui5-field-input-hover-border", commonClasses)}
                                              field         = {props.field}
                                              value         = {value}
                                              onChange      = {props.onChange}/>

}
